import React, { useState } from 'react';
import '../../css/modals/SimpleModal.css';
import { IoClose } from 'react-icons/io5';

function SimpleModal({ close, handlerClose, handleCloseModal, modal, url }) {
	// console.log(modal.title);

	return (
		<div className={`Inscriptions ${close ? 'close' : ''}`} onClick={handleCloseModal}>
			<div className={`Inscriptions-content-simple ${close ? 'close' : ''}`}>
				<button
					className='Inscriptions-close-btn'
					onClick={() => {
						handlerClose();
					}}
				>
					<IoClose />
				</button>

				<div className='container-info' style={{ marginBottom: '12px' }}>
					<div className='container-title'>
						<h2>¿Deseas financiar tu máster?</h2>
					</div>

					<p>Habla con nosotros para mayor información</p>

					<a
						href={url}
						// target='_blank'
						className='btn-camb-simple'
						onClick={() =>
							setTimeout(() => {
								handlerClose();
							}, 2000)
						}
					>
						Escríbenos
					</a>
				</div>
			</div>
		</div>
	);
}

export default SimpleModal;
